import React, { useState } from 'react'
import { i18nTranslate } from 'src/utils'
import { Button } from 'react-bootstrap'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'
import ItemDetails from './ItemDetails'
import './styles.scss'

const BundleIncludedItemsCollapse = ({
  customButtonClass = '',
  customWrapperClass = '',
  includedItems = [],
  disableTabIndex = 0,
}) => {
  const [showIncludedBundleItems, setShowIncludedBundleItems] = useState(false)
  const toggleIncludedBundleItems = () => {
    setShowIncludedBundleItems(!showIncludedBundleItems)
  }
  const numberOfIncludedItems = includedItems.length
  return (
    <div className={customWrapperClass}>
      <div className="bundle-items-collapse-wrapper">
        <Button
          className={`bundle-items-collapse-button ${customButtonClass}`}
          tabIndex={disableTabIndex}
          variant="link"
          onClick={toggleIncludedBundleItems}>
          {i18nTranslate('bundle.includedItems', 'Included Items')}
          {` (${numberOfIncludedItems}) `}
          {showIncludedBundleItems ? (
            <IoIosArrowUp size={16} />
          ) : (
            <IoIosArrowDown size={16} />
          )}
        </Button>
      </div>
      {showIncludedBundleItems && (
        <div className="d-flex flex-row flex-wrap bundle-items-list-wrapper">
          {includedItems.map((item, index) => {
            return (
              <ItemDetails
                key={index}
                itemDetails={{
                  name: item?.name,
                  image: item?.skuProperties?.imageURL || '',
                  qty: item?.skuQuantity,
                  skuId: item?.id,
                }}
                customClass="included-item-wrapper"
              />
            )
          })}
        </div>
      )}
    </div>
  )
}

export default BundleIncludedItemsCollapse
